export const setCalendDisplay = (item, location = "") => ({
  type: 'SET_CALEND_DISPLAY',
  payload: item,
  location: location
});